export default {
    title: "Soporte",
    description:
        "En caso de dudas, póngase en contacto con el soporte a través de WhatsApp o consulte nuestro centro de ayuda.",
    service_hours_title: "Horario de Atención:",
    service_hours_description:
        "Lunes a viernes de 09:00 a 12:00 y de 13:00 a 17:00",
    whatsapp_button: "Atención vía WhatsApp",
    help_center_button: "Ver centro de ayuda",
    emergency_title: "Guardia:",
    emergency_description:
        "Para solicitudes de emergencia fuera de nuestro horario de atención, por favor complete el formulario de guardia.",
    emergency_button: "Formulario de Guardia",
};
